/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { JobStatus } from "./job-status";
import { JobEntry } from "./job-entry";

export class JobState {
    id: number;
    siteId: number;
    lat: number;
    long: number;
    timeCreated: Date;
    timeCompleted: Date;
    dueDate: Date;
    lastUpdated: Date;
    status: JobStatus;
    masternautReference: string;
    addMasternaut: boolean;
    assignedTimeStart: Date;
    assignedTimeEnd: Date;
    assignedUsersList: number[] = [];
    assignedText: string;
    description: string;
    descriptionWithNotes: string;
    entries: JobEntry[] = [];
    rowVersion: number[];
}
